import React, {useEffect, useState} from "react";
import {AxiosError} from "axios";
import {ErrorResponseData} from "../../../../models/core/response";
import {Col, Form, Modal, Row, Select} from "antd";
import {useTranslate} from "../../../../hooks/translate.hook";
import {InvoiceData} from "../../../../models/documents/invoices/invoice-data/invoice.data";
import {invoiceService} from "../../../../services/documents/invoices/invoices.service";
import {notifications} from "../../../../services/notifications/notifications";
import dayjs from "dayjs";
import {accountPickupAuthorizationsService} from "../../../../services/accounts/account.pickup-authorizations.service";
import {
    PickupAuthorization
} from "../../../../models/accounts/customer-account/wholesale-account/wholesale.account.pickup-authorizations";
import Date from "../../../date/date";

interface InvoicesPickupAuthorizationModalProps {
    invoice: InvoiceData,
    onClose: () => void,
    onSuccess: () => void
}
export const InvoicesPickupAuthorizationModal: React.FC<InvoicesPickupAuthorizationModalProps> = ({invoice, onClose, onSuccess}) => {

    const t = useTranslate();
    const [loading, setLoading] = useState<boolean>(false);
    const [form] = Form.useForm();

    const [items, setItems] = useState<PickupAuthorization[]>([]);

    useEffect(() => {
        accountPickupAuthorizationsService
            .getAll(invoice.account.id)
            .then(items => setItems(items))

    }, []);

    return (
        <Modal
            open
            confirmLoading={loading}
            title={t("Pickup authorization")}
            okText={t("OK")}
            cancelText={t("CANCEL")}
            onOk={() => form.submit()}
            centered
            onCancel={() => {
                onClose();
                form.resetFields();
            }}
        >
            <Form
                form={form}
                layout="vertical"
                name={"set_date_modal"}
                initialValues={{
                    date: dayjs()
                }}
                onFinish={() => form
                    .validateFields()
                    .then(values => {
                        setLoading(true);
                        invoiceService.setPickupAuthorization(invoice.id, values.authId)
                            .then(() => {
                                form.resetFields();
                                onSuccess();
                                notifications.successfully()
                                return onClose();
                            }, (e: AxiosError<ErrorResponseData>) => {
                                if (e.response?.data.fields) {
                                    form.setFields(e.response?.data?.fields);
                                }
                            })
                            .then(() =>
                                onClose(),
                                (e: any) => form.setFields(e.response?.data?.fields))
                            .finally(() => setLoading(false));
                    })
                }
            >
                <Row gutter={10}>
                    <Col span={24}>
                        <Form.Item
                            name="authId"
                            label={"Person"}
                            rules={[{required: true, message: t("FROM.ERROR.PLEASE_SELECT_VALUE")}]}
                        >
                            <Select>
                                {items.map(item => (
                                    <Select.Option key={item.id}>{item.number} (<Date dateString={item.date} />, {item.authorizedPerson})</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}
